<template>
<v-list-item @click='$emit("selected", item)' >
  <!-- <pre v-text='item' /> -->
  <v-list-item-avatar v-if='profilePicture || initials' >
    <v-img v-if='profilePicture' :src='profilePicture' />
    <span v-else v-text='initials' ></span>
  </v-list-item-avatar>
  <v-list-item-content >
    <slot name='title' :fullname='fullname' >
    <v-list-item-title v-text="fullname" />
    </slot>
    <v-list-item-subtitle v-if='profession' >
      {{ profession }}
      <slot name="chips" >
      </slot>
    </v-list-item-subtitle>
  </v-list-item-content>
  <slot name='actions' ></slot>
  <v-list-item-action v-if='withChevron' >
    <v-btn icon ><v-icon >mdi-chevron-right</v-icon></v-btn>
  </v-list-item-action>
</v-list-item>
</template>
<script>
export default {
  name: 'PractitionerListItem',
  props: {
    item: { type: Object, required: true },
    withChevron: { type: Boolean, default: false }
  },
  computed: {
    fullname () {
      // normalize all the different ways that full name comes in :face_palm:
      let p = this.item
      if (p.full_name) { return p.full_name }
      if (p.user && p.user.id) {
        return `${p.user.first_name} ${p.user.last_name}`
      }
      if (p.practitioner_name) { return p.practitioner_name }
      if (p.first_name) {
        return `${p.first_name} ${p.last_name}`
      }
      return ''
    },
    profilePicture () {
      let pic = null
      if (this.item) {
        let pic = this.getObjectPath(this.item, 'profile_picture')
        if (pic) { return pic }

        pic = this.getObjectPath(this.item, 'profile.profile_picture')
        if (pic) { return pic }

        pic = this.getObjectPath(this.item, 'practitioner_media.profile')
        if (pic) { return pic }
      }
      return pic
    },
    initials () {
      if (this.fullname) {
        let items = this.fullname.split(' ')
        if (items && items.length > 0) {
          return items.slice(0, 2).map((word) => { return word[0] }).join('')
        }
      }
      return null
    },
    profession () {
      if (this.item && this.item.practitioner_profession) {
        return this.item.practitioner_profession
      }
      if (this.item && this.item.profession) {
        return this.item.profession
      }
      return null
    }
  }
}
</script>
